import {api} from './api';
import { CompanyPlanAdListItem, PlanAdListItem } from '../types';

export const planAdsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		planAdsList: builder.query<CompanyPlanAdListItem[], void>({
			query: () => ({
				url: 'planAds/list',
				method: 'GET',
			}),
			providesTags: ['CompanyPlanAds'],
		}),
		planAdslistByPlanIdPublic: builder.query<PlanAdListItem[], string | number>({
			query: (planId: string | number) => ({
				url: `planAds/listByPlanIdPublic/${planId}`,
				method: 'GET',
			}),
			providesTags: ['PlanAds'],
		}),
		planAdsCreate: builder.mutation({
			query: ({planId, description}) => ({
				url: 'planAds',
				method: 'POST',
				body: {planId, description},
			}),
			invalidatesTags: ['PlanAds', 'CompanyPlanAds'],
		}),
		planAdsDelete: builder.mutation({
			query: ({id}) => ({
				url: `planAds/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['PlanAds', 'CompanyPlanAds'],
		}),
		publishPlanAd: builder.mutation({
			query: ({id}) => ({
				url: `planAds/${id}/publish`,
				method: 'PUT',
			}),
			invalidatesTags: ['PlanAds', 'CompanyPlanAds'],
		}),
		unpublishPlanAd: builder.mutation({
			query: ({id}) => ({
				url: `planAds/${id}/unpublish`,
				method: 'PUT',
			}),
			invalidatesTags: ['PlanAds', 'CompanyPlanAds'],
		}),
	}),
});

export const { usePlanAdsCreateMutation, usePlanAdsDeleteMutation, usePlanAdsListQuery, usePlanAdslistByPlanIdPublicQuery, usePublishPlanAdMutation, useUnpublishPlanAdMutation } = planAdsApi;
